<template>
  <el-dialog
    ref="servicesDialog"
    :visible.sync="config.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :fullscreen="!isDesktop"
    :top="marginTop"
    :show-close="false"
    custom-class="pop_page noscroll header_40 servicesDialog"
  >
    <div slot="title" class="header">
      <div class="left">
        <el-button v-if="!isDesktop" class="tap-btn iconfont my-back size20" @click="close" />
        &nbsp;
      </div>
      <div class="middle">
        {{ $t('i.allSerivce') }}
      </div>
      <div class="float-right align-right">
        <el-button class="tap-btn" @click="goto('setup')">
          <i class="iconfont my-dot-more" />
        </el-button>
        <el-button v-if="isDesktop" class="tap-btn iconfont my-close size20" @click="close" />
      </div>
    </div>
    <div v-show="config.show" class="my-container bg-22" :style="{ 'width': '100%', 'height': 'calc(100% - 50px)', 'overflow': 'hidden auto' }">
      <div class="user-btns padding-top8">
        <div class="bg-22 padding-top8 padding-bottom12">
          <div class="padding4 align-left size14 color-99"> &nbsp; {{ $t('i.serivce') }}</div>
          <el-row>
            <el-col :span="5">
              <el-badge v-if="loginStatus" :value="formateNums(state.unread.total)" :hidden="!state.unread.total">
                <el-button class="tap-btn iconfont my-message" @click="goto('message')" />
                <div>{{ $t('i.message') }}</div>
              </el-badge>
            </el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-task" @click="goto('task')" /><div>{{ $t('i.task') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-sign" @click="goto('sign')" /><div>{{ $t('i.sign') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-items" @click="goto('items')" /><div>{{ $t('i.items') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-worth" @click="goto('wallet')" /><div>{{ $t('i.money') }}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="5"><el-button class="tap-btn iconfont my-orders" @click="goto('order')" /><div>{{ $t('i.order') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-paper" @click="openSelecter({ 'title': $t('i.paper'), 'table': 'paper', 'keyfield': 'paperid', 'maxSelectCount': 20, 'simple': false, 'showActions': false, 'batchDelete': true })" /><div>{{ $t('i.blueprint') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-sn" @click="openSelecter({ 'title': $t('i.sn'), 'table': 'sn', 'keyfield': 'snid', 'maxSelectCount': 1, 'simple': true, 'leftBack': true })" /><div>{{ $t('i.sn') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-vip" @click="goto('vip')" /><div>{{ $t('i.vip') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-invite" @click="goto('invite')" /><div>{{ $t('i.invite') }}</div></el-col>
          </el-row>
        </div>
      </div>
      <div class="user-btns padding-top8">
        <div class="bg-22 padding-top8 padding-bottom12">
          <div class="padding4 align-left size14 color-99"> &nbsp; {{ $t('i.works') }}</div>
          <el-row>
            <el-col :span="8"><el-button class="tap-btn iconfont my-material" @click="emit('openDraft', ['draft'])" /><div>{{ $t('i.localDrafts') }}</div></el-col>
            <el-col :span="8"><el-button class="tap-btn iconfont my-pixel" @click="emit('openResource', ['work'])" /><div>{{ $t('i.myWorks') }}</div></el-col>
            <!-- <el-col :span="6"><el-button class="tap-btn iconfont my-ai-paint" @click="emit('openResource', ['paint'])" /><div>{{ $t('i.aiWorks') }}</div></el-col> -->
          </el-row>
        </div>
      </div>
      <div class="user-btns padding-top8">
        <div class="bg-22 padding-top8 padding-bottom12">
          <div class="padding4 align-left size14 color-99"> &nbsp; {{ $t('i.create') }}</div>
          <el-row>
            <el-col :span="8"><el-button class="tap-btn iconfont my-aigc" @click="goto('aiart')" /><div>{{ $t('i.start_aigc') }}</div></el-col>
            <el-col :span="8"><el-button class="tap-btn iconfont my-vox" @click="openVoxel()" /><div>{{ $t('i.voxEditer') }}</div></el-col>
            <el-col :span="8"><el-button class="tap-btn iconfont my-gridsfy" @click="goto('editer', [])" /><div>{{ $t('i.editer') }}</div></el-col>
          </el-row>
          <el-row>
            <el-col :span="8"><el-button class="tap-btn iconfont my-avatar" @click="emit('openPopPage', [{ 'type': 'toBrickfy' }])" /><div>{{ $t('i.createPixelPuzzle') }}</div></el-col>
            <el-col :span="8"><el-button class="tap-btn iconfont my-bean" @click="emit('openPopPage', [{ 'type': 'toBeadsPixel' }])" /><div>{{ $t('i.aiBeadsPixel') }}</div></el-col>
            <el-col :span="8"><el-button class="tap-btn iconfont my-post-add" @click="emit('openPost')" /><div>{{ $t('i.addPost') }}</div></el-col>
          </el-row>
          <!--el-row>
            <el-col :span="6"><el-button class="tap-btn iconfont my-ai-paint" @click="emit('openAiPaint')" /><div>{{ $t('i.aiart') }}</div></el-col>
            <el-col :span="6"><el-button class="tap-btn iconfont my-pixel" @click="view.createNewfile = true" /><div>{{ $t('i.newCanvas') }}</div></el-col>
            <el-col :span="6"><el-button class="tap-btn iconfont my-cartoon" @click="emit('openPopPage', [{ 'type': 'toCartoon' }])" /><div>{{ $t('i.aiCartoon') }}</div></el-col>
          </el-row-->
        </div>
      </div>
      <!--div class="user-btns padding-top8">
        <div class="bg-22 padding-top8 padding-bottom12">
          <div class="padding4 align-left size14 color-99"> &nbsp; {{ $t('i.content') }}</div>
          <el-row>
            <el-col :span="5"><el-button class="tap-btn iconfont my-pixel" @click="goto('works')" /><div>{{ $t('i.works') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-zone" @click="goto('zone')" /><div>{{ $t('i.zone') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-ai-paint" @click="goto('aiart')" /><div>{{ $t('i.aiart') }}</div></el-col>
            <el-col :span="5"><el-button class="tap-btn iconfont my-blockchain" @click="goto('nft')" /><div>{{ $t('i.nft') }}</div></el-col>
          </el-row>
        </div>
      </div-->
      <div class="user-btns padding-top8">
        <div class="bg-22 padding-top8 padding-bottom12">
          <div class="padding4 align-left size14 color-99"> &nbsp; {{ $t('i.interact') }}</div>
          <el-row>
            <el-col :span="6"><el-button class="tap-btn iconfont my-down-round" @click="goto('download')" /><div>{{ $t('i.download') }}</div></el-col>
            <el-col :span="6"><el-button class="tap-btn iconfont my-blank-star" @click="goto('favor')" /><div>{{ $t('i.favor') }}</div></el-col>
            <el-col :span="6"><el-button class="tap-btn iconfont my-praise-blank" @click="goto('praise')" /><div>{{ $t('i.praise') }}</div></el-col>
            <el-col :span="6"><el-button class="tap-btn iconfont my-footprint" @click="goto('footprint')" /><div>{{ $t('i.footprint') }}</div></el-col>
          </el-row>
        </div>
      </div>
      <div class="user-btns padding-top8">
        <div class="bg-22 padding-top8 padding-bottom12">
          <div class="padding4 align-left size14 color-99"> &nbsp; {{ $t('i.other') }}</div>
          <el-row>
            <el-col :span="6"><el-button class="tap-btn iconfont my-personal" @click="goto('profile')" /><div>{{ $t('i.myProfile') }}</div></el-col>
            <el-col :span="6"><el-button class="tap-btn iconfont my-setting" @click="goto('account')" /><div>{{ $t('i.myAccount') }}</div></el-col>
          </el-row>
        </div>
      </div>
      <div class="user-btns padding-top8" />
    </div>
  </el-dialog>
</template>
<script>
import { mixins } from '@/mixins/common'
import utils from '@/js/utils'
export default {
  components: {},
  mixins: [mixins],
  computed: {
    config() {
      return this.view.services
    }
  },
  methods: {
    formateNums: utils.formateNums,
    handle(act, data) {
      this.emit(act, data)
    },
    // 打开选择器
    openSelecter(config) {
      this.emit('openSelecter', [config])
    },
    logout() {
      this.emit('logout')
      this.goto('works')
    },
    close() {
      this.config.show = false
      this.goto('user')
    }
  }
}
</script>
